export default __webpack_public_path__ + "static/media/organisation-new.1d5feab4.svg";